import { tv } from "../../variants/tv.js";
const CLIP_PATH = 'overflow-x-clip py-3 -my-3';
const carouselVariants = tv({
    slots: {
        wrapperParentSlot: 'h-full',
        wrapperSlot: 'h-full',
        rootSlot: 'relative m-auto h-full',
        viewportSlot: '',
        containerSlot: 'pan-y pinch-zoom relative flex',
        slideSlot: '',
        prevButtonSlot: 'absolute top-[calc(50%-20px)]',
        nextButtonSlot: 'absolute top-[calc(50%-20px)]',
        hiddenButtonSlot: 'absolute top-[calc(50%-20px)]',
        dotsPaginationSlot: 'absolute right-0 bottom-2 left-0 flex items-center justify-center',
        dotButtonSlot: 'inline-flex h-7 w-7 cursor-pointer items-center justify-center',
        dotSlot: 'h-2 w-2 rounded-full border border-neutral-1 bg-neutral-12/10',
        dotSelectedSlot: 'h-3 w-3 bg-neutral-1'
    },
    variants: {
        type: {
            image: {},
            content: {}
        },
        numSlides: {
            'one-two-three': {},
            'one-two-three-four': {},
            'one-two-two': {},
            one: {},
            'two-four-six': {},
            'three-six-nine': {},
            'two-three-four-five-six-seven': {}
        },
        slideGap: {
            3: {}
        },
        rounded: {
            'top-left': {
                viewportSlot: 'rounded-tl-lg'
            },
            top: {
                viewportSlot: 'rounded-t-lg'
            },
            left: {
                viewportSlot: 'rounded-l-lg'
            },
            all: {
                viewportSlot: 'rounded-lg'
            },
            none: {}
        },
        slideWidth: {
            min: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-64'
            },
            auto: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0'
            },
            same: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                rootSlot: '@container relative mx-auto',
                slideSlot: 'flex-shrink-0 flex-grow-0'
            },
            image: {
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0 basis-full'
            }
        },
        isDotSelected: {
            true: {
                dotSlot: 'h-3 w-3 bg-neutral-1'
            },
            false: {
                dotSlot: 'h-2 w-2 border-neutral-1 bg-neutral-12/10'
            }
        },
        loop: {
            true: {},
            false: {}
        },
        hideArrowsOnMobileOrTouch: {
            responsive: {},
            always: {},
            never: {}
        },
        bleed: {
            defaultBleed: {},
            fullBleed: {},
            customBleed: {},
            responsiveBleed: {}
        },
        bleedSpacing: {
            2: {},
            3: {},
            4: {},
            6: {},
            8: {}
        },
        fullBleedPadding: {
            2: {},
            3: {},
            4: {},
            6: {},
            8: {}
        }
    },
    compoundVariants: [
        {
            hideArrowsOnMobileOrTouch: 'responsive',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px] hidden md:block',
                nextButtonSlot: 'absolute top-[calc(50%-12px)] right-[8px] hidden md:block',
                hiddenButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px] hidden md:block'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'always',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px] hidden',
                nextButtonSlot: 'absolute top-[calc(50%-12px)] right-[8px] hidden',
                hiddenButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px] hidden'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'never',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px]',
                nextButtonSlot: 'absolute top-[calc(50%-12px)] right-[8px]',
                hiddenButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px]'
            }
        },
        {
            slideWidth: 'image',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px]',
                nextButtonSlot: 'absolute top-[calc(50%-12px)] right-[8px]',
                hiddenButtonSlot: 'absolute top-[calc(50%-12px)] left-[8px]'
            }
        },
        {
            slideWidth: 'min',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]',
                nextButtonSlot: 'absolute top-[calc(50%-20px)] right-[-8px] 2xl:right-[-16px]',
                hiddenButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]'
            }
        },
        {
            slideWidth: 'auto',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]',
                nextButtonSlot: 'absolute top-[calc(50%-20px)] right-[-8px] 2xl:right-[-16px]',
                hiddenButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]'
            }
        },
        {
            slideWidth: 'same',
            class: {
                prevButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]',
                nextButtonSlot: 'absolute top-[calc(50%-20px)] right-[-8px] 2xl:right-[-16px]',
                hiddenButtonSlot: 'absolute top-[calc(50%-20px)] left-[-8px] 2xl:left-[-16px]'
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'image',
            class: {
                viewportSlot: 'overflow-hidden'
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'min',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'auto',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'defaultBleed',
            slideWidth: 'same',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'image',
            class: {
                viewportSlot: 'overflow-hidden'
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'min',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto'
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'auto',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto'
            }
        },
        {
            bleed: 'fullBleed',
            slideWidth: 'same',
            fullBleedPadding: '2',
            class: {
                wrapperParentSlot: 'w-full',
                wrapperSlot: 'ml-[calc(50%-50vw)] w-screen',
                rootSlot: 'flex max-w-[calc(100%-var(--spacing)*2)] items-center',
                viewportSlot: 'm-auto'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'image',
            class: {
                viewportSlot: 'overflow-hidden'
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '2',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '2',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '2',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-2 px-2`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '3',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-3 px-3`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '3',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-3 px-3`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '3',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-3 px-3`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '4',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '4',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '4',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '6',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-6 px-6`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '6',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-6 px-6`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '6',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-6 px-6`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'min',
            bleedSpacing: '8',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-8 px-8`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'auto',
            bleedSpacing: '8',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-8 px-8`
            }
        },
        {
            bleed: 'customBleed',
            slideWidth: 'same',
            bleedSpacing: '8',
            class: {
                viewportSlot: `${CLIP_PATH} -mx-8 px-8`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'image',
            class: {
                viewportSlot: 'overflow-hidden'
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '2',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-2 px-2 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-3 px-3 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-3 px-3 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '3',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-3 px-3 md:-mx-4 md:px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'min',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'auto',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            bleed: 'responsiveBleed',
            slideWidth: 'same',
            bleedSpacing: '4',
            class: {
                rootSlot: 'sm:ml-0 sm:w-full',
                viewportSlot: `${CLIP_PATH} -mx-4 px-4`
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-two-three',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/3)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @2xl:w-[var(--slide-width-2)] @5xl:w-[var(--slide-width-3)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-two-three-four',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/3)-var(--slide-gap))]',
                    '[--slide-width-4:calc(((100%-var(--peek-amount))/4)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @xl:w-[var(--slide-width-2)] @4xl:w-[var(--slide-width-3)] @6xl:w-[var(--slide-width-4)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one-two-two',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/2)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @3xl:w-[var(--slide-width-2)] @6xl:w-[var(--slide-width-3)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'one',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc(100%-var(--peek-amount)-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount)))-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount)))-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @3xl:w-[var(--slide-width-2)] @6xl:w-[var(--slide-width-3)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'two-four-six',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc((100%-var(--peek-amount))/2-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/4)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/6)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @3xl:w-[var(--slide-width-2)] @6xl:w-[var(--slide-width-3)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'two-three-four-five-six-seven',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc((100%-var(--peek-amount))/2-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/3)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/4)-var(--slide-gap))]',
                    '[--slide-width-4:calc(((100%-var(--peek-amount))/5)-var(--slide-gap))]',
                    '[--slide-width-5:calc(((100%-var(--peek-amount))/6)-var(--slide-gap))]',
                    '[--slide-width-6:calc(((100%-var(--peek-amount))/7)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @lg:w-[var(--slide-width-2)] @2xl:w-[var(--slide-width-3)] @4xl:w-[var(--slide-width-4)] @6xl:w-[var(--slide-width-5)] @7xl:w-[var(--slide-width-6)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: 'three-six-nine',
            slideGap: '3',
            class: {
                rootSlot: [
                    '[--slide-gap:12px]',
                    '[--peek-amount:16px]',
                    '[--slide-width-1:calc((100%-var(--peek-amount))/3-var(--slide-gap))]',
                    '[--slide-width-2:calc(((100%-var(--peek-amount))/6)-var(--slide-gap))]',
                    '[--slide-width-3:calc(((100%-var(--peek-amount))/9)-var(--slide-gap))]'
                ],
                slideSlot: 'w-[var(--slide-width-1)] @3xl:w-[var(--slide-width-2)] @6xl:w-[var(--slide-width-3)]'
            }
        }
    ],
    defaultVariants: {
        type: 'content',
        numSlides: 'one-two-three',
        rounded: 'all',
        slideGap: '3',
        slideWidth: 'auto',
        hideArrowsOnMobileOrTouch: 'responsive',
        bleed: 'defaultBleed',
        bleedSpacing: '4'
    }
});
const CarouselTypeOptions = [
    'image',
    'content'
];
const CarouselPaginationOptions = [
    'numbers',
    'dots'
];
const CarouselRoundedOptions = Object.keys(carouselVariants.variants.rounded);
const CarouselSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth);
const CarouselImageSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' === key);
const CarouselContentSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' !== key);
const CarouselNumSlidesOptions = Object.keys(carouselVariants.variants.numSlides);
const CarouselHideArrowsOnMobileOrTouchOptions = Object.keys(carouselVariants.variants.hideArrowsOnMobileOrTouch);
const CarouselBleedOptions = Object.keys(carouselVariants.variants.bleed);
const CarouselBleedSpacingOptions = Object.keys(carouselVariants.variants.bleedSpacing);
const CarouselFullBleedPaddingOptions = Object.keys(carouselVariants.variants.fullBleedPadding);
export { CarouselBleedOptions, CarouselBleedSpacingOptions, CarouselContentSlideWidthOptions, CarouselFullBleedPaddingOptions, CarouselHideArrowsOnMobileOrTouchOptions, CarouselImageSlideWidthOptions, CarouselNumSlidesOptions, CarouselPaginationOptions, CarouselRoundedOptions, CarouselSlideWidthOptions, CarouselTypeOptions, carouselVariants };
